const userRoute = [
  {
    path: '/AccountSetup',
    name: 'AccountSetup',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/AccountSetup.vue'),
    meta: { title: '账户设置', showBackBtn: true }
  },
  {
    path: '/Balance',
    name: 'Balance',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/Balance.vue'),
    meta: { title: '我的分润', showBackBtn: true }
  },
  {
    path: '/BalancePre',
    name: 'BalancePre',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/BalancePre.vue'),
    meta: { title: '预存账户', showBackBtn: true }
  },
  {
    path: '/AgentManagement',
    name: 'AgentManagement',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/AgentManagement.vue'),
    meta: { title: '拓展代理', showBackBtn: true }
  },
  {
    path: '/PackageConfig',
    name: 'PackageConfig',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/PackageConfig.vue'),
    meta: { title: '我的售价', showBackBtn: true }
  },
  {
    path: '/AgentAccount',
    name: 'AgentAccount',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/AgentAccount.vue'),
    meta: { title: '提现记录', showBackBtn: true }
  },
  {
    path: '/ChangePassword',
    name: 'ChangePassword',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/ChangePassword.vue'),
    meta: { title: '密码修改', showBackBtn: true }
  },
  {
    path: '/Order',
    name: 'Order',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/Order.vue'),
    meta: { title: '流量订单', showBackBtn: true }
  },
  {
    path: '/SimTransfer',
    name: 'SimTransfer',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/SimTransfer.vue'),
    meta: { title: '划拨SIM卡', showBackBtn: true }
  },
  // {
  //   path: '/PricesList',
  //   name: 'PricesList',
  //   component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/PricesList.vue'),
  //   meta: { title: '价格表' }
  // },
  // {
  //   path: '/RevisePrice',
  //   name: 'RevisePrice',
  //   component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/RevisePrice.vue'),
  //   meta: { title: '充值价格修改' }
  // },
  {
    path: '/QRcode',
    name: 'QRcode',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/QRcode.vue'),
    meta: { title: '二维码', showBackBtn: true }
  },
  {
    path: '/Grade',
    name: 'Grade',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/Grade.vue'),
    meta: { title: '等级表', showBackBtn: true }
  },
  {
    path: '/SwitchAccount',
    name: 'SwitchAccount',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/SwitchAccount.vue'),
    meta: { title: '切换账号', showBackBtn: true }
  },
  {
    path: '/firstLoginPage',
    name: 'firstLoginPage',
    component: () => import(/* webpackChunkName: "user" */ '../../views/Index/components/user/firstLoginPage.vue'),
    meta: { title: '首次登录设置', showBackBtn: true }
  }
]

export default userRoute
